<div class="container">

  <app-header-dialog [iconName]="'star'">
    Reembolso
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <div class='content'>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Banco</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.bank"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.bank.hasError('required')">
          O Banco é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Nome do Banco</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.bankName"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.bankName.hasError('required')">
          O Nome do Banco é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Agência</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.agency"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.agency.hasError('required')">
          A Agência é obrigatória
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Conta</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.account"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.account.hasError('required')">
          A Agência é obrigatória
        </mat-error>
      </mat-form-field>

      <div>
        <mat-form-field class="number-width" appearance="outline">
          <mat-label>%</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.discount"
            autocomplete="off">
          <mat-error *ngIf="entityForm.controls.discount.hasError('required')">
            A Porcentagem é obrigatória
          </mat-error>
        </mat-form-field>

        <mat-form-field class="number-width" appearance="outline">
          <mat-label>Valor</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.total"
            autocomplete="off">
          <mat-error *ngIf="entityForm.controls.total.hasError('required')">
            O Valor é obrigatório
          </mat-error>
        </mat-form-field>



        <mat-form-field class='date-width' appearance="outline">
          <mat-label>Solicitação</mat-label>
          <input matInput [matDatepicker]="pickerRequest" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.dateRequest">
          <mat-datepicker-toggle matSuffix [for]="pickerRequest"></mat-datepicker-toggle>
          <mat-datepicker #pickerRequest></mat-datepicker>
          <mat-error *ngIf="entityForm.controls.dateRequest.hasError('required')">
            A data de solicitação é obrigatoria
          </mat-error>
        </mat-form-field>

        <mat-form-field class='date-width' appearance="outline">
          <mat-label>Pagamento</mat-label>
          <input matInput [matDatepicker]="pickerRefund" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.dateRefund">
          <mat-datepicker-toggle matSuffix [for]="pickerRefund"></mat-datepicker-toggle>
          <mat-datepicker #pickerRefund></mat-datepicker>
          <mat-error *ngIf="entityForm.controls.dateRefund.hasError('required')">
            A data de pagamento é obrigatoria
          </mat-error>
        </mat-form-field>

      </div>

    </div>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <button mat-raised-button (click)='updateRefund()' *ngIf='!done' [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>